import { observer } from 'mobx-react-lite'
import { ChoiceTile, type ITooltipProps, Tooltip, type IIconsVector } from 'shared/ui'
import styles from './styles.module.scss'

export type AssignInboxType = 'exist' | 'new'

export type IAssignInboxOption = {
  value: AssignInboxType
  title: string
  icon: IIconsVector
  disabled?: boolean
  disabledTooltip?: ITooltipProps | null
}

type IChooseAssignInboxTypeProps = {
  selectedType: AssignInboxType
  onSelectType: (type: AssignInboxType) => void
  inboxOptions: IAssignInboxOption[]
}

export const ChooseAssignInboxType = observer(
  ({ selectedType, onSelectType, inboxOptions }: IChooseAssignInboxTypeProps) => {
    return (
      <div className={styles.cardsContainer}>
        {inboxOptions.map((option) => (
          <Tooltip
            key={option.value}
            fullWidth
            withoutPointer
            visibility={option.disabledTooltip ? 'visible' : 'hidden'}
            {...option.disabledTooltip}
          >
            <ChoiceTile
              className={styles.choiceTile}
              key={option.value}
              iconProps={{
                icon: option.icon as IIconsVector,
                fontSize: 24,
                color: option.disabled
                  ? 'var(--content-neutral-primary)'
                  : selectedType === option.value
                  ? 'var(--content-brand-primary)'
                  : 'var(--content-primary-tertiary)',
              }}
              title={option.title}
              isSimleIcon
              value={option.value}
              checked={selectedType === option.value}
              setChoiceTile={(value) => onSelectType(value as AssignInboxType)}
              titleProps={{
                ariaLabel: 'ChoiceTile',
                variant: 'body-md-regular',
              }}
              disabled={option.disabled}
            />
          </Tooltip>
        ))}
      </div>
    )
  }
)
